import gql from 'graphql-tag'

export const PAGE_QUERY = gql`
query {
  page404 {
    data {
      attributes {
        intro {
          Intro {
            Title
            Caption
            Description
          }
          Button {
            href
            label
            isExternal
          }
        }
        seo {
          metaTitle
          metaDescription
          metaImage {
            data {
              attributes {
                url
                alternativeText
                formats
              }
            }
          }
          metaSocial {
            socialNetwork
            title
            description
            image {
              data {
                attributes {
                  url
                  alternativeText
                  formats
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
